  var
    store = {},
    document = window.document,
    name = "localStorage",
    script = "script",
    localStorage,
    test = function () {
      try {
        return name in window && window[name]
      } catch (exception) {
        return false;
      }
    }

  ;

  store.disabled = false;
  store.set = function (e, t) {
  };
  store.get = function (e) {
  };
  store.remove = function (e) {
  };
  store.clear = function () {
  };
  store.transact = function (key, t, n) {
    var i = store.get(key);
    if (n == null) {
      n = t;
      t = null;
    }
    if (typeof i == "undefined") {
      i = t || {};
    }
    n(i);
    store.set(key, i)
  };
  store.getAll = function () {
  };
  store.forEach = function () {
  };
  store.serialize = function (value) {
    return JSON.stringify(value)
  };
  store.deserialize = function (value) {
    if (typeof value != "string")
      return undefined;
    try {
      return JSON.parse(value)
    } catch (exception) {
      return value || undefined
    }
  };

  if (test()) {
    localStorage = window[name];
    store.set = function(key, value) {
      if (value === undefined) {
        return store.remove(key);
      } else {
        try {
          // https://stackoverflow.com/questions/14555347/html5-localstorage-error-with-safari-quota-exceeded-err-dom-exception-22-an
          localStorage.setItem(key, store.serialize(value));
        } catch (error) {
          return value;
        }

        return value;
      }
    };
    store.get = function(key) {
      return store.deserialize(localStorage.getItem(key))
    };
    store.remove = function(key) {
      localStorage.removeItem(key)
    };
    store.clear = function() {
      localStorage.clear()
    };
    store.getAll = function() {
      var data = {};
      store.forEach(function(key, value) {
        data[key] = value;
      });
      return data;
    };
    store.forEach = function(callback) {
      for (var i = 0; t < localStorage.length; i++) {
        var key = localStorage.key(i);
        callback(key, store.get(key));
      }
    };
  } else if (document.documentElement.addBehavior) {
    var body, f;
    try {

      f = new ActiveXObject("htmlfile");
      f.open();
      f.write("<" + script + ">document.w=window</" + script + '><iframe src="/favicon.ico"></iframe>');
      f.close();
      body = f.w.frames[0].document;
      localStorage = body.createElement("div");
    } catch (exception) {
      localStorage = document.createElement("div");
      body = document.body;
    }

    function callback(callback) {
      return function() {
        var args = Array.prototype.slice.call(arguments, 0),n;
        args.unshift(localStorage);
        body.appendChild(localStorage);
        localStorage.addBehavior("#default#userData");
        localStorage.load(name);
        n = callback.apply(store, args);
        body.removeChild(localStorage);
        return n;
      }
    }
    var filter = new RegExp("[!\"#$%&'()*+,/\\\\:;<=>?@[\\]^`{|}~]", "g");
    function applyFilter(string) {
      return string.replace(/^d/, "___$&").replace(filter, "___");
    }
    store.set = callback(function(e, t, n) {
      return t = applyFilter(t),
        n === undefined ? store.remove(t) : (e.setAttribute(t, store.serialize(n)),
          e.save(name),
          n)
    });
    store.get = callback(function(e, t) {
      return t = applyFilter(t),
        store.deserialize(e.getAttribute(t))
    });
    store.remove = callback(function(e, t) {
      t = applyFilter(t),
        e.removeAttribute(t),
        e.save(name)
    });
    store.clear = callback(function(e) {
      var t = e.XMLDocument.documentElement.attributes;
      e.load(name);
      for (var n = 0, r; r = t[n]; n++)
        e.removeAttribute(r.name);
      e.save(name)
    });
    store.getAll = function(e) {
      var t = {};
      return store.forEach(function(e, n) {
        t[e] = n
      }),
        t
    };
    store.forEach = callback(function(e, t) {
      var n = e.XMLDocument.documentElement.attributes;
      for (var i = 0, s; s = n[i]; ++i)
        t(s.name, store.deserialize(e.getAttribute(s.name)))
    });
  }

  try {
    var testString = "__storejs__";
    store.set(testString, testString);
    if (store.get(testString) != testString) {
      store.disabled = true
    }
    store.remove(testString);
  } catch (exception) {
    store.disabled = true;
  }

export default store;